export const extractName = (interval, isolated_point) => {
  if (interval) {
    const { from, to } = interval;
    let name;
    if (from?.value !== "-inf" && to?.value === "+inf") {
      name = `${from?.inclusive ? "\u2265" : ">"} ${from?.value}`;
    } else if (from?.value === "-inf" && to?.value !== "+inf") {
      name = `${to?.inclusive ? "\u2264" : "<"} ${to?.value}`;
    } else {
      name = `${from?.value} ${from?.inclusive ? "\u2264" : "<"} x ${
        to?.inclusive ? "\u2264" : "<"
      } ${to?.value}`;
    }

    return name;
  }

  return `${isolated_point?.value ?? "blank value"}`;
};

export const extractOrdinalValues = (column, intervalValue) => {
  const { intervals, values, isolated_points } = column;
  const interval = intervals.find(
    interval => interval.id === intervalValue
  )?.interval;
  if (interval) {
    const from = values.find(value => value.id === interval?.from);
    const to =
      values.find(value => value.id === interval?.to) ??
      values.reduce((prev, current) =>
        +prev.id > +current.id ? prev : current
      );
    if (from && to) {
      if (from.id === to.id) {
        return `${from.id}`;
      }

      if (from.id > to.id || to.id > 999999) {
        return `from ${to?.name} to ${from?.name}`;
      }
    }

    return `from ${from?.name} to ${to?.name}`;
  }

  const isolated_point = isolated_points.find(
    point => point.id === intervalValue
  );
  const value = isolated_point
    ? values.find(value => value.id === isolated_point.value)
    : { name: "blank value" };
  return value?.name ?? "blank value";
};

export const roundNumbers = (value, decPlaces) =>
  Math.round((value + Number.EPSILON) * Math.pow(10, decPlaces)) /
  Math.pow(10, decPlaces);
